import * as mutationTypes from './mutationTypes';
import {OTP_STATUS} from "@/store/otp/constants";

const inProgressOtpStates = ['DELIVERED_HANDSET', 'DELIVERED_GATEWAY', 'IN_TRANSIT'];

const mutations = {
  [mutationTypes.REQUEST_OTP](state) {
    state.otpStatus = OTP_STATUS.REQUEST_STARTED;
    state.otpError = null;
  },
  [mutationTypes.REQUEST_OTP_SUCCESS](state) {
    state.otpStatus = OTP_STATUS.REQUEST_SUCCESS;
  },
  [mutationTypes.REQUEST_OTP_ERROR](state, { otpError }) {
    state.otpStatus = OTP_STATUS.FAILED_REQUEST;
    state.otpError = otpError;
  },
  [mutationTypes.FETCH_OTP_STATE](state) {
    state.otpStatus = OTP_STATUS.FETCH_STARTED;
    state.otpError = null;
  },
  [mutationTypes.FETCH_STATE_SUCCESS](state, { otpStatus, hours, minutes }) {
    state.otpStatus = inProgressOtpStates.includes(otpStatus) ? OTP_STATUS.REQUEST_SUCCESS : otpStatus;
    state.otpHours = hours;
    state.otpMinutes = minutes;
  },
  [mutationTypes.FETCH_STATE_ERROR](state, { otpError }) {
    state.otpStatus = OTP_STATUS.FAILED_FETCH;
    state.otpError = otpError;
  },
  [mutationTypes.SEND_OTP](state) {
    state.otpStatus = OTP_STATUS.SEND_STARTED;
    state.otpError = null;
  },
  [mutationTypes.SEND_OTP_SUCCESS](state) {
    state.otpStatus = OTP_STATUS.FINISHED;
  },
  [mutationTypes.SEND_OTP_ERROR](state, { otpError }) {
    state.otpStatus = OTP_STATUS.FAILED_SEND;
    state.otpError = otpError;
  },
  [mutationTypes.REQUIRE_RESEND](state) {
    state.otpStatus = OTP_STATUS.REQUIRE_RESEND;
  },
  [mutationTypes.CLEAR_ERROR](state) {
    state.otpError = null;
  },
};

export default mutations;
